import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import "../css/index.css"
import { message } from 'antd';
import Cookies from 'js-cookie';
import { loadStripe } from '@stripe/stripe-js';
import { TiArrowBack } from "react-icons/ti";


function Index(params) {

    const loginemail = Cookies.get("email")
    const loginname = Cookies.get("Name")
    const id = Cookies.get("id")
    const token = Cookies.get("Token")
    const token2 = Cookies.get("Token2")


    const logourl =Cookies.get("logourl") || params.logourl;
    const backgroundcolor = Cookies.get("backgroundcolor") || params.backgroundcolor;
    const color = Cookies.get("color") || params.color;
    const Buttonbackgroundcolor = Cookies.get("Buttonbackgroundcolor") || params.Buttonbackgroundcolor;
    const Buttoninsidecolor = Cookies.get("Buttoninsidecolor") || params.Buttoninsidecolor;
    const prinarycolor = Cookies.get("prinarycolor") || params.prinarycolor;
    const prinarycolortext = Cookies.get("prinarycolortext") || params.prinarycolortext;
    const seconderycolor = Cookies.get("seconderycolor") || params.seconderycolor;
    const portalid = Cookies.get("portalid") || params.portalid;


    let navigate = useNavigate();
    const [email, setemail] = useState("")
    const [password, setpassword] = useState("")
    const [forgetpassword, setforgetpassword] = useState("1")
    const [forgetpasswordemail, setforgetpasswordemail] = useState("")
    const [forgetpasswordotp, setforgetpasswordotp] = useState("")
    const [forgetpasswordnewpassword, setforgetpasswordnewpassword] = useState("")

    const addcard = async (item) => {

        const hide = message.loading("Action in progress", 0)
        console.log(item)
        const stripe = await loadStripe("pk_live_51MsenqJSzdsymN5jGOTIP3q4qBmD4PDra9chWFQYDC6RCchx2jLlIgdDRrUnhI24QhZeNeAqEo9tc6l3oiR4SWc3000yjqG8qW");

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("CID", item[0].customerId);
        urlencoded.append("PID", item[0].Id);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };
        const response = await fetch("https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/addcar-session", requestOptions);

        const session = await response.json();

        const result = stripe.redirectToCheckout({
            sessionId: session.id
        });

        if (result.error) {
            console.log(result.error);
        }
        await setTimeout(() => {
            hide(); // Call hide to stop the loading message
            message.success("Action completed successfully");
        }, 2000);

    }

    const formsub = async (e) => {

        e.preventDefault();

        const hide = message.loading("Action in progress", 0)
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("email", email);
        urlencoded.append("password", password);
        urlencoded.append("portalid", portalid);

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        await fetch(process.env.REACT_APP_APIURL + "/login", requestOptions)
            .then(response => response.json())
            .then(async result => {
                if (result === "user not found") {
                    message.error("Please enter a correct Email Address")
                } else if (result === "Password is incorrect.") {
                    message.error("Please enter a correct Password")
                } else if (result === "Account is disable by Admin") {
                    message.error("Account is disable by Admin")


                } else {
                    if (result.admin === true) {
                        message.success("logged in")
                        Cookies.set('email', result.email, { expires: 7 }); // Expires in 7 days
                        Cookies.set('id', result._id, { expires: 7 }); // Expires in 7 days
                        Cookies.set('Name', result.name, { expires: 7 }); // Expires in 7 days
                        Cookies.set('Token', "dskgfsdgfkgsdfkjg35464154845674987dsf@53", { expires: 7 }); // Expires in 7 days
                        navigate("/dashboard")
                    } else {

                        if (result.CardID) {
                            Cookies.set('email', result.email, { expires: 7 }); // Expires in 7 days
                            Cookies.set('id', result._id, { expires: 7 }); // Expires in 7 days
                            Cookies.set('Name', result.name, { expires: 7 }); // Expires in 7 days
                            Cookies.set('Token', "sdrfg&78967daghf#wedhjgasj(dlsh6kjsdg", { expires: 7 }); // Expires in 7 days


                            const myHeaders3 = new Headers();
                            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

                            const urlencoded3 = new URLSearchParams();
                            urlencoded3.append("email", result.email);

                            const requestOptions3 = {
                                method: "POST",
                                headers: myHeaders3,
                                body: urlencoded3,
                                redirect: "follow"
                            };


                            await fetch("https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/getmeetschudulebyemail", requestOptions3)
                                .then((response) => response.json())
                                .then(async result2 => {

                                    if (result._id === result2.id) {

                                        await Cookies.set('Token2', "afdksjfjsdgfjgsdugcsduygfcsdvcfgsdcfgtysdftd", { expires: 7 }); // Expires in 7 days
                                        await navigate("/dashboard")

                                    } else {
                                        await navigate("/dashboard")

                                    }



                                }).catch((error) => console.error(error));




                        } else {
                            const info = [{ Id: result._id, customerId: result.customerID }]
                            addcard(info)
                        }




                    }
                }



            })
            .catch(error => console.log('error', error));
        await setTimeout(() => {
            hide(); // Call hide to stop the loading message
            // message.success("Action completed successfully");
        }, 100);
    }





    const formsubsentotp = async (e) => {

        e.preventDefault();

        const hide = message.loading("Action in progress", 0)
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("email", forgetpasswordemail);
        urlencoded.append("portalid", portalid);


        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        fetch(process.env.REACT_APP_APIURL + "/sentotp", requestOptions)
            .then(response => response.text())
            .then(result => {
                if (result === "user not found") {
                    message.error("Please enter a correct Email Address")
                } else if (result === "user deactivated") {

                    message.error("Account is Disable by Admin")
                } else if (result === "prac found") {
                    setforgetpassword("5")

                }

                else {
                    message.success("OTP has been sent")
                    setforgetpassword("3")
                }



            })
            .catch(error => console.log('error', error));
        await setTimeout(() => {
            hide(); // Call hide to stop the loading message
            message.success("Action completed successfully");
        }, 2000);
    }


    const formsubsentsetpass = async (e) => {

        e.preventDefault();
        const hide = message.loading("Action in progress", 0)

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("email", forgetpasswordemail);
        urlencoded.append("otp", forgetpasswordotp);


        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        fetch("https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/setnewpassword", requestOptions)
            .then(response => response.text())
            .then(result => {
                if (result === "otp match") {
                    message.success("OTP Match")
                    setforgetpassword("4")
                } else {
                    message.error("Please enter the correct OTP")


                }



            })
            .catch(error => console.log('error', error));
        await setTimeout(() => {
            hide(); // Call hide to stop the loading message
            message.success("Action completed successfully");
        }, 2000);
    }

    const formsubsentsetpass2 = async (e) => {

        e.preventDefault();
        const hide = message.loading("Action in progress", 0)

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

        var urlencoded = new URLSearchParams();
        urlencoded.append("email", forgetpasswordemail);
        urlencoded.append("password", forgetpasswordnewpassword);


        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        fetch("https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/setnewpassword2", requestOptions)
            .then(response => response.text())
            .then(result => {
                if (result === "password changed please login ") {
                    message.success("password changed please login")
                    setforgetpassword("1")
                } else {
                    message.error("something wrong please try again later")


                }



            })
            .catch(error => console.log('error', error));
        await setTimeout(() => {
            hide(); // Call hide to stop the loading message
            message.success("Action completed successfully");
        }, 2000);
    }


    useEffect(() => {
        if (token === "dskgfsdgfkgsdfkjg35464154845674987dsf@53" || token === "sdrfg&78967daghf#wedhjgasj(dlsh6kjsdg") {
            navigate("/dashboard")

        }
    }, [])




    return (<>


        <div className='mainindex' style={{ backgroundColor: backgroundcolor }} >

            <div className='loginbox'>


                <div className='logoinbox'>
                    <img alt='' src={logourl} width={"90%"} />

                </div>
                {forgetpassword === "1" && <>
                    <form onSubmit={formsub}>
                        <h5 style={{ margin: '10px', color: color }}>Welcome to practitioner login page</h5>

                        <input value={email} onChange={(e) => setemail(e.target.value)} placeholder='Email' required type='email' name='email' />
                        <input value={password} onChange={(e) => setpassword(e.target.value)} placeholder='Password' required type='password' name='password' />

                        <button style={{ backgroundColor: Buttonbackgroundcolor, color: Buttoninsidecolor }} >Login</button>

                        <h5 className='hovar' style={{ margin: '10px', color: color }} onClick={() => setforgetpassword("2")}>Forgot your password?</h5>
                    </form>

                </>}
                {forgetpassword === "2" && <>
                    <form onSubmit={formsubsentotp}>

                        <h5 style={{ margin: '10px', color: color }}>Please Enter Your Name and email to proceed</h5>
                        <div onClick={() => setforgetpassword("1")} className='hovar' style={{ display: 'flex', alignItems: 'center', width: "100%", justifyContent: 'flex-start', color: color }}><TiArrowBack />Back</div>
                        <input placeholder='Name' required type='text' name='name' />


                        <input value={forgetpasswordemail} onChange={(e) => setforgetpasswordemail(e.target.value)} placeholder='Email' required type='email' name='email' />

                        <button style={{ backgroundColor: Buttonbackgroundcolor, color: Buttoninsidecolor }} >Submit</button>


                    </form>
                </>}

                {forgetpassword === "5" && <>
                    <div >

                        <h5 style={{ margin: '10px', color: color }}>We have received your request. Our team will be in touch with you via email shortly.</h5>

                        <button className='button' onClick={() => setforgetpassword("1")} style={{ backgroundColor: Buttonbackgroundcolor, color: Buttoninsidecolor }} >Back to Login</button>


                    </div>
                </>}

                {forgetpassword === "3" && <>
                    <form onSubmit={formsubsentsetpass}>
                        <h5 style={{ margin: '10px', color: color }}>Enter The OTP</h5>
                        <div onClick={() => setforgetpassword("2")} className='hovar' style={{ display: 'flex', alignItems: 'center', width: "100%", justifyContent: 'flex-start', color: color }}><TiArrowBack />Back</div>

                        <input value={forgetpasswordotp} onChange={(e) => setforgetpasswordotp(e.target.value)} placeholder='Please enter the OTP' required type='text' name='otp' />

                        <button style={{ backgroundColor: Buttonbackgroundcolor, color: Buttoninsidecolor }}>Submit</button>


                    </form>
                </>}




                {forgetpassword === "4" && <>
                    <form onSubmit={formsubsentsetpass2}>
                        <h5 style={{ margin: '10px', color: color }}>Enter The New Password</h5>
                        <div onClick={() => setforgetpassword("3")} className='hovar' style={{ display: 'flex', alignItems: 'center', width: "100%", justifyContent: 'flex-start', color: "#6E4E9F" }}><TiArrowBack />Back</div>

                        <input value={forgetpasswordnewpassword} onChange={(e) => setforgetpasswordnewpassword(e.target.value)} placeholder='new Password' required type='password' name='password' />
                        <input pattern={forgetpasswordnewpassword} title='Please match the password' placeholder='Confirm Password' required type='password' name='password' />

                        <button style={{ backgroundColor: Buttonbackgroundcolor, color: Buttoninsidecolor }}>Submit</button>


                    </form>
                </>}

            </div>


        </div>
    </>)
}

export default Index